import { Widget, isWidgetOpened, addResponseMessage, toggleMsgLoader, toggleInputDisabled, renderCustomComponent, deleteMessages, markAllAsRead } from 'react-chat-widget'
import { useEffect, useRef, useState } from 'react'
import 'react-chat-widget/lib/styles.css'
import "./index.scss"
import logo from "utils/stylesheets/logo/logo.png"
import { FaMicrophone, FaRobot } from "react-icons/fa"
import { FaStop } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux"
import { chatBot, librarian, message } from 'state_management'
import { analyzeAudioBlob } from 'utils/scripts/analyseAudio'
import { Dropdown } from 'react-bootstrap'
import { TbSquareLetterT, TbSquareLetterG, TbSquareLetterC } from 'react-icons/tb'


export default function ChatBot() {
  const dispatch = useDispatch()
  const widgetContainerRef = useRef()
  const inputRef = useRef(null);

  const userName = useSelector((state) => state.auth.memberId)
  const status = useSelector((state) => state.chatBot.status)
  const conversation = useSelector((state) => state.chatBot)
  const chatbots = useSelector((state) => state.librarian.chatbots)
  const selectedChatbot = useSelector((state) => state.chatBot.selectedChatbot)
  const defaultChatbot = useSelector((state) => state.auth.defaultChatbot)
  const activeConversationId = useSelector((state) => state.chatBot.conversationId)
  const isAdmin = useSelector((state) => state.auth.role === "admin" || state.auth.role === "customer_admin")




  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [insertionLength, setInsertionLength] = useState(0);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [textInserted, setTextInserted] = useState(false);
  const [isWidgetVisible, setisWidgetVisible] = useState(isWidgetOpened());



  useEffect(() => {
    if (isAdmin) {
      dispatch(librarian.fetchAdminChatbots()).then(res => {
        dispatch(chatBot.setChatbot(res.find((chatbot) => chatbot.name === "PlannerTech Help")))
      })
    } else {
      dispatch(librarian.fetchChatbots()).then((res) => {
        dispatch(chatBot.setChatbot(res.find((chatbot) => chatbot.name === "PlannerTech Help")))
      })
    }
  }, [dispatch, defaultChatbot, isAdmin]);

  useEffect(() => {
    markAllAsRead()
    deleteMessages()
    addResponseMessage(`Hi, I'm your AI CHATBOT, specialized in Plannertech & Librarian help documentation, and the data repositories you have imported.\n
You can also always reach out to our Human Support on pt@arnvind.com from 9-16 CET.\n
How can I help you? :-)`)
  }, [userName]);

  const handleRefresh = () => {
    dispatch(chatBot.refreshChat())
    deleteMessages()
  }

  const RefreshButton = ({ onRefresh }) => {
    return <button className="rcw-refresh-button" title="Clear the conversation" onClick={onRefresh}>Clear</button>
  };

  const SpeechToTextButton = ({ onClick }) => {
    return <button className="rcw-stt-button" onClick={onClick}>
        {isRecording ? <FaStop /> : <FaMicrophone />}
      </button>
  };

  useEffect(() => {
    if (status === 'finished') {
      toggleMsgLoader(false)
      toggleInputDisabled(false)
    }
  }, [status]);

  // Updates the cursor position when the user clicks or types in the input field
  useEffect(() => {
    const updateCursorPosition = (e) => {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const position = range.startOffset;
        setCursorPosition(position);
      }
    };

    if (isWidgetVisible) {
      // Delay the execution to wait for the DOM to update
      const timeoutId = setTimeout(() => {
        const inputDiv = document.querySelector('.rcw-input');
        if (inputDiv) {
          inputDiv.addEventListener('input', updateCursorPosition);
          inputDiv.addEventListener('click', updateCursorPosition);
        }
      }, 100);

      // Return a cleanup function
      return () => {
        clearTimeout(timeoutId);
        const inputDiv = document.querySelector('.rcw-input');
        if (inputDiv) {
          inputDiv.removeEventListener('input', updateCursorPosition);
          inputDiv.removeEventListener('click', updateCursorPosition);
        }
      };
    }
  }, [isWidgetVisible]);

  useEffect(() => {
    const launcher = document.querySelector('.rcw-launcher');
    if (launcher) {
      launcher.addEventListener('click', toggleWidgetVisibility);
    }

    return () => {
      if (launcher) {
        launcher.removeEventListener('click', toggleWidgetVisibility);
      }
    }
  }, [])


  // Highlights the inserted text from speech-to-text
  useEffect(() => {
    if (insertionLength > 0 && textInserted) {
      const inputDiv = document.querySelector('.rcw-input');
      if (inputDiv) {
        inputRef.current = inputDiv;
        inputDiv.focus();

        const range = document.createRange();
        const sel = window.getSelection();

        const textNode = inputDiv.firstChild;
        const startPos = cursorPosition - insertionLength;
        const endPos = cursorPosition;

        range.setStart(textNode, startPos);
        range.setEnd(textNode, endPos);
        sel.removeAllRanges();
        sel.addRange(range);

        setTextInserted(false);
      }
    }
  }, [insertionLength, cursorPosition, textInserted]);

  const toggleWidgetVisibility = () => {
    setisWidgetVisible(prevState => !prevState);
  };


  const setInput = (value) => {
    if (widgetContainerRef.current) {
      const inputDiv = widgetContainerRef.current.querySelector('.rcw-input');
      if (inputDiv) {
        inputDiv.innerText = value;
      }
    }
  };


  const handleNewUserMessage = (message) => {
  toggleMsgLoader(true);
  toggleInputDisabled(true);

  // Function to process the response and format the message
  const processResponse = (res) => {
    let fullMessage = res.message;

    if (res.links && res.links.length > 0) {
        fullMessage += "\n \nReferences: ";
        // Map over the links and format each with a newline and the tag
        const linksFormatted = res.links
        .map(link => `\n[${link.docId}] - [${link.tag}](${link.url})`)
        .join('');

      fullMessage += linksFormatted;
    }

    // Add the complete formatted message
    addResponseMessage(fullMessage);

    // Optionally, handle rendering the Refresh button if needed
    if (conversation.conversationList.length === 0) {
      renderCustomComponent(RefreshButton, { onRefresh: handleRefresh });
    }
  };

  // Determine the action based on whether there's an active conversation
  if (activeConversationId === "") {
    dispatch(chatBot.getAnswer({ isBot: false, message: message }, selectedChatbot.id))
      .then(processResponse)
      .finally(() => {
        // Additional finalization if needed
      });
  } else {
    dispatch(chatBot.getAnswer({ isBot: false, message: message }, selectedChatbot.id, activeConversationId))
      .then(processResponse)
      .finally(() => {
        // Additional finalization if needed
      });
  }
};


  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      setMediaRecorder(recorder);

      let audioChunks = [];

      recorder.addEventListener('dataavailable', event => {
        audioChunks.push(event.data);
      });

      recorder.addEventListener('stop', () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
        // Send audioBlob to backend here
        analyzeAudioBlob(audioBlob).then(isSpeechDetected => {
          if (isSpeechDetected) {
            dispatch(librarian.getSpeechToTextQuestion(audioBlob)).then((res) => {
              const newText = res.text.trim();

              if (widgetContainerRef.current) {
                const inputDiv = widgetContainerRef.current.querySelector('.rcw-input');
                if (inputDiv) {
                  const currentText = inputDiv.innerText;
                  const beforeCursor = currentText.substring(0, cursorPosition);
                  const afterCursor = currentText.substring(cursorPosition);

                  const updatedInput = `${beforeCursor}${newText}${afterCursor}`;
                  setInput(updatedInput);

                  const newCursorPosition = beforeCursor.length + newText.length;
                  setCursorPosition(newCursorPosition);
                  setInsertionLength(newText.length);
                  setTextInserted(true);
                }
              }
            });
          } else {
            return dispatch(message.warning(`No sound detected. Please try again.`))
          }
        });
        audioChunks = [];
      });

      recorder.start(500);
      setIsRecording(true);
    } catch (error) {
      return dispatch(message.warning(`No microphone detected. Please try again.`))
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      mediaRecorder.stream.getTracks().forEach(track => track.stop());
      setIsRecording(false);
    }
  };

  const toggleRecording = () => {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  return (
    <div className="chat-widget-container">
      <div ref={widgetContainerRef}>
        <Widget
          title="QC Librarian 3.8"
          subtitle={`Chatting with ${selectedChatbot ? selectedChatbot.name : "No chatbot selected"}`}
          handleNewUserMessage={handleNewUserMessage}
          launcherOpenImg={logo}
        />
      </div>
      {isWidgetVisible && (<SpeechToTextButton onClick={toggleRecording} />)}
      <div className="chat-messages-toolbar-dropdown">
        {isWidgetVisible && (
          <div className="chatbot-dropdown">
            <Dropdown
              drop="down"        // Opens the dropdown upwards
              align="end"      // Aligns the dropdown menu to the right
              onSelect={(eventKey) => {
                if (eventKey === "none") {
                  dispatch(chatBot.setChatbot({ id: "", name: "" }));
                } else {
                  dispatch(chatBot.setChatbot(chatbots.find((chatbot) => chatbot.id === eventKey)));
                }
              }}
            >
              <Dropdown.Toggle variant="link" className="rcw-chatbot-button-dropdown-toggle">
                <FaRobot size={20} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {chatbots.length > 0 &&
                  chatbots.map((chatbot) => (
                    <Dropdown.Item key={chatbot.id} eventKey={chatbot.id}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <span
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '250px',
                            marginRight: '10px',
                          }}
                          title={chatbot.name}
                        >
                          {chatbot.name}
                        </span>
                        <div style={{ flexShrink: 0 }}> {/* Prevents the icons from shrinking */}
                          {chatbot.uniqueForTeam ? (
                            <TbSquareLetterT size={20} title="Team chatbot" />
                          ) : chatbot.isGlobal ? (
                              <TbSquareLetterG size={20} title="Global chatbot" />
                            ) : (
                                <TbSquareLetterC size={20} title="Company-wide chatbot" />
                              )}
                        </div>
                      </div>
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
    </div>
  );
}
